import { CustomerApplicationForm } from "Hooks/Api/apiCustomerApplications";
import type { userType } from "Models/Enums";
import { IUserResult, store } from "Models/Store";

const editApplicationAuth: userType[] = [
	"SUPER_USER",
	"ADMIN",
	"ORGANISATION_MANAGER",
	"USER",
	"SALESPERSON",
];

const otherActionAuth: userType[] = [
	"SUPER_USER",
	"ADMIN",
	"ORGANISATION_MANAGER",
	"USER",
	"RESTRICTED_USER",
];

const deleteApplicationAuth: userType[] = [
	"SUPER_USER",
	"ADMIN",
	"ORGANISATION_MANAGER",
];

const elevatedColumnAuth: userType[] = [
	"SUPER_USER",
	"ADMIN",
	"ORGANISATION_MANAGER",
	"USER",
	"RESTRICTED_USER",
	// referral is unauthorised
];

const canEditSubsetOfFieldsOnReadonlyAuth: userType[] = ['SUPER_USER', 'ADMIN', 'ORGANISATION_MANAGER']

export type CustomerApplicationAuthorisation = {
	canEdit: boolean;
	canEditSubsetOfFieldsOnReadonly: boolean;
	canOtherAction: boolean;
	canDelete: boolean;
	elevatedColumnPermissions: boolean;
	canUserEditApplication: (application: CustomerApplicationForm) => boolean;
};

export function useCustomerApplicationAuthorisation(user?: IUserResult): CustomerApplicationAuthorisation {

	const userType = user?.userType;
	const canEdit = !!userType && editApplicationAuth.includes(userType);
	const canDelete = !!userType && deleteApplicationAuth.includes(userType);
	const canOtherAction = !!userType && otherActionAuth.includes(userType);
	const canEditSubsetOfFieldsOnReadonly = !!userType && canEditSubsetOfFieldsOnReadonlyAuth.includes(userType);
	const elevatedColumnPermissions = !!userType && elevatedColumnAuth.includes(userType);


	function canUserEditApplication(application: CustomerApplicationForm) {
		switch (userType) {
			case 'REFERRAL_PARTNER': return false;

			// Can edit if the owner
			case 'SALESPERSON':
			case 'RESTRICTED_USER': 
			case 'USER': {
				if (application.reassignedUserId == null) return application.ownerId == store.getUser?.id
				return application.reassignedUserId == store.getUser?.id;
			}
				
			// Can edit any
			case 'ADMIN':
			case 'ORGANISATION_MANAGER':
			case 'SUPER_USER': return true;

			default:
				return false;
		}
	}

	return {
		canEdit,
		canEditSubsetOfFieldsOnReadonly,
		canOtherAction,
		canDelete,
		elevatedColumnPermissions,
		canUserEditApplication:canUserEditApplication
	};
}